import { Center } from 'devextreme-react/cjs/map';
import React from 'react'
import Tree from "react-d3-tree";
import "bootstrap/dist/css/bootstrap.min.css";
function Structure() {

    
    const orgChart = {
    name: "CEO",
    children: [
      {
        name: "MES",
        children: [
          {
            name: "DFS",
            children: [{ name: "EDS" }, { name: "IAS" }, { name: "BIM" }],
          },
        ],
      },
      {
        name: "OD",
        children: [{ name: "TAG", children: [{ name: "HR" }] }],
      },
      {
        name: "ITE",
        children: [
          {
            name: "HR Manager",
            children: [{ name: "Recruiters" }, { name: "Payroll Specialists" }],
          },
          {
            name: "Operations Manager",
            children: [{ name: "Administrative Staff" }],
          },
        ],
      },
    ],
  };
  return (
     <div className="container-fluid">
            <div className="row justify-content-center align-items-start h-100">
              
                {/* Main content area - tree visualization */}
                <div className="col-lg-12 col-md-11 col-sm-12 col-12 d-flex justify-content-center align-items-start p-2">

                    <div style={{ width: "100%", 
                    height: "100vh",  
                    overflowX: "auto",
                     overflowY: "auto", 
                     minHeight: "600px"  
                     }}
                     >

                       <Tree
  data={orgChart}
  orientation="vertical"
  translate={{ x: window.innerWidth / 2.2, y: 100 }}
  zoom={1}
  nodeSvgShape={{
    shape: "circle",
    shapeProps: {
      r: 15,
      fill: "#7564e6",
      stroke: "#7564e6",
      strokeWidth: 2,
    },
  }}
  styles={{
    nodes: {
      node: {
        name: {
          fill: "#7564e6",
          fontSize: "13px",
          fontWeight: "600",
        },
      },
      leafNode: {
        name: {
          fill: "#7564e6",
          fontSize: "12px",
          fontWeight: "500",
        },
      },
    },
    links: {
      stroke: "#7564e6",
      strokeWidth: 2,
    },
  }}
/>


                    </div>
                </div>
                
                {/* Optional sidebar - empty but available for content */}
                <div className="col-lg-2 col-md-11 col-sm-12 col-12">
                </div>
            </div>
        </div>
  )
}

export default Structure;